import { useCallback } from 'react';

import isEqual from 'fast-deep-equal';

import { useAppSelector } from 'hooks/store';
import { useClientLists, useFieldValues, useIsValidFieldValues, useMultiRfm } from 'pages/audience/shared/hooks';
import { generateSearchParameters } from 'pages/audience/utilities';
import { selectAudienceIsMultiRfm, selectAudienceSelectedSearch } from 'store/selectors';
import { defaultSearch, defaultSearchMultiRfm, IFormCategory, MultiRfmSearch, SearchType } from 'types/api/audience';

export const useGenerateSearchParameters = () => {
  const advanced = useAppSelector(selectAudienceIsMultiRfm);
  const selectedSearch = useAppSelector(selectAudienceSelectedSearch, isEqual);

  const clientLists = useClientLists();
  const { fieldValues } = useFieldValues();
  const isValid = useIsValidFieldValues();
  const { groups, operation } = useMultiRfm();

  return useCallback(
    (categories?: IFormCategory[]) => {
      if (isValid) {
        if (advanced) {
          const parameters: MultiRfmSearch = {
            ...defaultSearchMultiRfm(),
            operation,
          };

          for (const { fieldValues: rfmSetFieldValues, name } of groups) {
            parameters.rfmSets = [
              ...parameters.rfmSets,
              {
                ...generateSearchParameters(
                  SearchType.Basic,
                  rfmSetFieldValues,
                  clientLists(rfmSetFieldValues),
                  categories
                ),
                name,
              },
            ];
          }

          return parameters;
        }

        const parameters = {
          ...defaultSearch(),
          ...generateSearchParameters(selectedSearch, fieldValues, clientLists(fieldValues), categories),
        };

        return parameters;
      }

      return defaultSearch();
    },
    [advanced, clientLists, fieldValues, groups, isValid, operation, selectedSearch]
  );
};
